import { auth, db, messaging } from "./firebase";
import {
  signInWithEmailAndPassword,
  signOut,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";

// Funkce pro registraci uživatele
const registerUser = async (email, password) => {
  const userCredential = await createUserWithEmailAndPassword(
    auth,
    email,
    password
  );
  const user = userCredential.user;

  // Uložíme uživatele s výchozí rolí "user" a přidáme Joker
  await setDoc(doc(db, "users", user.uid), {
    email,
    role: "user",
    jokerUsed: false,
  });

  return user;
};

// Funkce pro přihlášení uživatele
const loginUser = async (email, password) => {
  const userCredential = await signInWithEmailAndPassword(
    auth,
    email,
    password
  );
  const user = userCredential.user;
  const userDoc = await getDoc(doc(db, "users", user.uid));
  return { user, role: userDoc.exists() ? userDoc.data().role : "user" };
};

// Funkce pro odhlášení uživatele
const logoutUser = async () => {
  await signOut(auth);
};

export { auth, db, messaging, registerUser, loginUser, logoutUser };
